const sessionStorage = window.sessionStorage
export default {
  getItem(key) {
    const result = JSON.parse(sessionStorage.getItem(key))
    return result
  },
  setItem(key, value) {
    sessionStorage.setItem(key, JSON.stringify(value))
  },
  removeItem(key) {
    sessionStorage.removeItem(key)
  }
}
